import { render, staticRenderFns } from "./GalleryTextComponent.vue?vue&type=template&id=15bf5e4c&scoped=true&"
import script from "./GalleryTextComponent.vue?vue&type=script&lang=js&"
export * from "./GalleryTextComponent.vue?vue&type=script&lang=js&"
import style0 from "./GalleryTextComponent.vue?vue&type=style&index=0&id=15bf5e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf5e4c",
  null
  
)

export default component.exports